import React from 'react';
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';

export interface PartialDaySelectorProps {
    value: 'Full' | 'FirstHalf' | 'SecondHalf';
    onChange: (value: 'Full' | 'FirstHalf' | 'SecondHalf') => void;
    label: string;
    disabled?: boolean;
}

export const PartialDaySelector: React.FC<PartialDaySelectorProps> = ({
    value,
    onChange,
    label,
    disabled = false
}) => {
    return (
        <FormControl component="fieldset" disabled={disabled}>
            <FormLabel component="legend">{label}</FormLabel>
            <RadioGroup
                row
                value={value}
                onChange={(e) => onChange(e.target.value as 'Full' | 'FirstHalf' | 'SecondHalf')}
            >
                <FormControlLabel value="Full" control={<Radio />} label="Full Day" />
                <FormControlLabel value="FirstHalf" control={<Radio />} label="First Half" />
                <FormControlLabel value="SecondHalf" control={<Radio />} label="Second Half" />
            </RadioGroup>
        </FormControl>
    );
};
